<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="options"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :placeholder="placeholder"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="batchClassification.loading"
          :style="{ opacity: batchClassification.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay coincidencias para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { batchClassification } from '@/febos/aduanas/batches/store/getters';
import { fetchBatchClassification } from '@/febos/aduanas/batches/store/actions';

export default {
  computed: {
    ...mapGetters('batches', {
      batchClassification: batchClassification.name
    }),
    optionSelected() {
      const findOption = this.batchClassification.list
        .find((option) => option.value === this.value);
      if (findOption) {
        return { ...findOption, label: `${findOption?.value} - ${findOption?.label}` };
      }
      return null;
    },
    isDisabled() {
      return this.disabled
        || !this.batchClassification.list.length
        || this.batchClassification.loading;
    },
    options() {
      return this.batchClassification.list
        .map((option) => ({ ...option, label: `${option.value} - ${option.label}` }));
    }
  },
  methods: {
    ...mapActions('batches', {
      fetchBatchClassification: fetchBatchClassification.name
    }),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.batchClassification.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchBatchClassification();
  },
  props: {
    name: { type: String, required: true },
    placeholder: String,
    autocomplete: { type: Boolean, default: false },
    label: { type: String, default: 'Clasificación' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};
</script>
